import {useEffect, useState} from "react";
import IconHighLight from "../../../public/images/highlight.svg";
import IconStrikeText from "../../../public/images/strike-text.svg";
import IconUnderline from "../../../public/images/underline.svg";
import IconClose from "../../../public/images/close.svg";
import {useTranslation} from "next-i18next";
import { SketchPicker } from 'react-color'
import Select from "./Select";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";
import LineSelect from "./LineSelect";
import useObjectEditStore from "../../../store/useObjectEditStore";

const HighLightSelect = ({}) => {
  const store = useEditorPanelButtonStore();
  const objectEditStore = useObjectEditStore();
  const {t} = useTranslation();
  const [isHideColor, setIsHideColor] = useState(true);
  const [color, setColor] = useState('transparent');
  const [typeCurrent, setTypeCurrent] = useState('');
  const buttonContent = <div className="select__button-text">
    <IconHighLight className="select__icon"/>
    <span>{t(`convert-and-edit:editor.highlight`)}</span>
  </div>

  const variants = [
    {
      type: "line-through",
      text: "Strike out",
      element: <IconStrikeText className="select__icon"/>,
    },
    {
      type: "background",
      text: "Highlight",
      element: <IconHighLight className="select__icon select__icon__black-color"/>,
    },
    {
      type: "underline",
      text: "Underline",
      element: <IconUnderline className="select__icon"/>,
    },
  ];

  useEffect(() => {
    if (isHideColor || !store.isOpenModal.includes('highlight')) {
      const colorFind = store.colors.findIndex((value) => value === color)
      if (colorFind === -1)
        store.setColors([...store.colors, color])
    }
  }, [color, isHideColor, store, store.isOpenModal])

  useEffect(() => {
    const objectEdit = () => {
      if (objectEditStore.objectEdit.element) {
        if (store.highlight.type !== 'draw' && store.highlight.type !== 'background'){
          objectEditStore.objectEdit.element.style.textDecoration = `${store.highlight.line}px ${store.highlight.color} ${store.highlight.type}`;
          return {
            ...objectEditStore.objectEdit,
            textDecoration: store.highlight.type,
          };
        }
        else {
          if (store.highlight.type === 'background') {
            objectEditStore.objectEdit.element.style.background = store.highlight.color;
            return {
              ...objectEditStore.objectEdit,
              background: store.highlight,
            };
          }
          else {
            return {
              ...objectEditStore.objectEdit,
            };
          }
        }
      }
      return objectEditStore.objectEdit
    }
    objectEditStore.setObjectEdit(objectEdit());
  }, [store.highlight])

  return (
    <Select tab='highlight' buttonContent={buttonContent}>
      <>
        <ul className={`highlight-select__list select__list ${store.isOpenModal.includes('highlight') ? "": "select__list-hide"}`}>
          {variants.map(variant =>
            <li key={variant.type} value={variant.type}
                className={`select__variant ${variant.type === store.highlight.type ? "select__variant-active" : ""}`}
                onClick={() => {
                  setTypeCurrent(variant.type)
                  setIsHideColor(false)
                }}>
              {variant.element}
              <span>{variant.text}</span>
            </li>,
          )}
        </ul>
        <div className={`select__color-picker ${isHideColor || store.isOpenModal !== 'highlight' ? 'select__color-picker__hide' : ''}`} key="highlightColor">
          <button className="select__color-picker__close-button" onClick={() => setIsHideColor(true)}>
            <IconClose className="select__icon"/>
          </button>
          <div className="line-select">
            <span>{objectEditStore.fontLine}px</span>
            <LineSelect />
          </div>
          <SketchPicker color={color} onChange={ (currentColor) => {
            store.setHighlight({type: typeCurrent, color: currentColor.hex, line: objectEditStore.fontLine});
            setColor(currentColor.hex);
          }} presetColors={store.colors}/>
        </div>
      </>
    </Select>
  );
};

export default HighLightSelect;
